/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminImportUsageItemDto,
    AdminImportUsageItemDtoFromJSON,
    AdminImportUsageItemDtoFromJSONTyped,
    AdminImportUsageItemDtoToJSON,
} from './AdminImportUsageItemDto';

/**
 * 
 * @export
 * @interface AdminImportUsageDto
 */
export interface AdminImportUsageDto {
    /**
     * Total number of users for percentage calculation
     * @type {number}
     * @memberof AdminImportUsageDto
     */
    totalUsers: number;
    /**
     * Import usage statistics by platform
     * @type {Array<AdminImportUsageItemDto>}
     * @memberof AdminImportUsageDto
     */
    items: Array<AdminImportUsageItemDto>;
}

export function AdminImportUsageDtoFromJSON(json: any): AdminImportUsageDto {
    return AdminImportUsageDtoFromJSONTyped(json, false);
}

export function AdminImportUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImportUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['totalUsers'],
        'items': ((json['items'] as Array<any>).map(AdminImportUsageItemDtoFromJSON)),
    };
}

export function AdminImportUsageDtoToJSON(value?: AdminImportUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalUsers': value.totalUsers,
        'items': ((value.items as Array<any>).map(AdminImportUsageItemDtoToJSON)),
    };
}

